<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('presentations.FechaPresentacionDesdeHasta')}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.from')}}
                          <el-form-item prop="FechaPresentacionDesde">
                              <el-date-picker
                                class="bg-white dark:bg-darkblue-900"
                                v-model="form.FechaPresentacionDesde.value"
                                type="date"
                                format="dd-MM-yyyy"
                                :picker-options="dateRangeOptions"
                                placeholder="dd-mm-aaaa"
                                ref="datePickerFechaPresentacionDesde"
                                @blur="onBlurDatePickerMixin('.datePickerFechaPresentacionDesde-popover')"
                                @focus="onFocusDatePickerMixin('.datePickerFechaPresentacionDesde-popover')"
                                @keydown.native="captureKeyNotChrome"
                                popper-class="datePickerFechaPresentacionDesde-popover"
                                >
                              </el-date-picker>
                          </el-form-item>
                        </label>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.to')}}
                        <el-form-item prop="FechaPresentacionHasta">
                            <el-date-picker
                              class="bg-white dark:bg-darkblue-900"
                              v-model="form.FechaPresentacionHasta.value"
                              :picker-options="dateRangeOptions"
                              type="date"
                              format="dd-MM-yyyy"
                              placeholder="dd-mm-aaaa"
                              ref="datePickerFechaPresentacionHasta"
                              @blur="onBlurDatePickerMixin('.datePickerFechaPresentacionHasta-popover')"
                              @focus="onFocusDatePickerMixin('.datePickerFechaPresentacionHasta-popover')"
                              @keydown.native="captureKeyNotChrome"
                              popper-class="datePickerFechaPresentacionHasta-popover"
                              >
                            </el-date-picker>
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('presentations.CodigoTramite')}}
                <el-form-item prop="CodigoTramite">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.CodigoTramite.value"
                    maxlength="10"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('presentations.DescripcionTramite')}}
                <el-form-item prop="DescripcionTramite">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.DescripcionTramite.value"
                    maxlength="100"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('presentations.Asunto')}}
                <el-form-item prop="Asunto">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Asunto.value"
                    maxlength="100"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('presentations.Telefono')}}
                <el-form-item prop="Telefono">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Telefono.value"
                    maxlength="12"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('presentations.Email')}}
                <el-form-item prop="Email">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Email.value"
                    maxlength="100"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.PresentarRecurso.value"
                prop="PresentarRecurso"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="presentationsaeatfilter"
              >
                <template slot="label">{{$t('presentations.PresentarRecurso')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('presentations.Observaciones')}}
                <el-form-item prop="Observaciones">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Observaciones.value"
                    maxlength="100"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('presentations.NumAsiento')}}
                <el-form-item prop="NumAsiento">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.NumAsiento.value"
                    maxlength="100"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('presentations.CSVRecibo')}}
                <el-form-item prop="CSVRecibo">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.CSVRecibo.value"
                    maxlength="100"
                  />
                </el-form-item>
              </label>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('presentations.URLRecibo')}}
                <el-form-item prop="URLRecibo">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.URLRecibo.value"
                    maxlength="100"
                  />
                </el-form-item>
              </label>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.tipoPresentacionEstado.value"
                prop="tipoPresentacionEstado"
                :options="tiposPresentacionEstadoForAccessibleSelect"
                :withFormItem="true"
                id-prefix="presentationsaeatfilter"
              >
                <template slot="label">{{$t('presentations.Estado')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('presentations.Error')}}
                <el-form-item prop="Error">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.Error.value"
                    maxlength="100"
                  />
                </el-form-item>
              </label>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { ROLES } from '@/config/roles'
import { TIPOS_PRESENTACION_ESTADO } from '@/config/tipos-presentacion-estado'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'neopresentations',
      isOpen: this.panelOpen,
      links: [],
      form: {
        CodigoTramite: { label: i18n.t('presentations.CodigoTramite'), value: '' },
        DescripcionTramite: { label: i18n.t('presentations.DescripcionTramite'), value: '' },
        Asunto: { label: i18n.t('presentations.Asunto'), value: '' },
        Telefono: { label: i18n.t('presentations.Telefono'), value: '' },
        Email: { label: i18n.t('presentations.Email'), value: '' },
        PresentarRecurso: { label: i18n.t('presentations.PresentarRecurso'), value: '' },
        Observaciones: { label: i18n.t('presentations.Observaciones'), value: '' },
        NumAsiento: { label: i18n.t('presentations.NumAsiento'), value: '' },
        CSVRecibo: { label: i18n.t('presentations.CSVRecibo'), value: '' },
        URLRecibo: { label: i18n.t('presentations.URLRecibo'), value: '' },
        FechaPresentacionDesde: { label: i18n.t('presentations.FechaPresentacionDesde'), value: '' },
        FechaPresentacionHasta: { label: i18n.t('presentations.FechaPresentacionHasta'), value: '' },
        tipoPresentacionEstado: { label: i18n.t('presentations.Estado'), value: '' },
        Error: { label: i18n.t('presentations.Error'), value: '' },
      },
      tiposPresentacionEstado: TIPOS_PRESENTACION_ESTADO,
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
    }
  },

  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    roles: function () {
      return ROLES.filter(r => {
        if (r.only) {
          return r.only.includes(this.role)
        }
        return true
      })
    },
    valuesForAccessibleSelect: function () {
      return this.values.map(item => ({
        id: item.value,
        name: item.label
      }))
    },
    tiposPresentacionEstadoForAccessibleSelect: function () {
      return this.tiposPresentacionEstado.map(item => ({
        id: item.id,
        name: item.name
      }))
    },
    hasPermModuleSMS () {
      return this.$store.getters['auth/hasModuleEnvioSMS'] && 
        (this.role === 'Administrador' || this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador')
    },
    hasModulePermisosGruposTraspasoNEOs () {
      return this.$store.getters['auth/hasModulePermisosGruposTraspasoNEOs']
    },
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.CodigoTramite.value = _temp.CodigoTramite !== undefined && _temp.CodigoTramite.value !== '' ? _temp.CodigoTramite.value : ''
        this.form.DescripcionTramite.value = _temp.DescripcionTramite !== undefined && _temp.DescripcionTramite.value !== '' ? _temp.DescripcionTramite.value : ''
        this.form.Asunto.value = _temp.Asunto !== undefined && _temp.Asunto.value !== '' ? _temp.Asunto.value : ''
        this.form.Telefono.value = _temp.Telefono !== undefined && _temp.Telefono.value !== '' ? _temp.Telefono.value : ''
        this.form.Email.value = _temp.Email !== undefined && _temp.Email.value !== '' ? _temp.Email.value : ''
        this.form.PresentarRecurso.value = _temp.PresentarRecurso !== undefined && _temp.PresentarRecurso.value !== '' ? _temp.PresentarRecurso.value : ''
        this.form.Observaciones.value = _temp.Observaciones !== undefined && _temp.Observaciones.value !== '' ? _temp.Observaciones.value : ''
        this.form.NumAsiento.value = _temp.NumAsiento !== undefined && _temp.NumAsiento.value !== '' ? _temp.NumAsiento.value : ''
        this.form.CSVRecibo.value = _temp.CSVRecibo !== undefined && _temp.CSVRecibo.value !== '' ? _temp.CSVRecibo.value : ''
        this.form.URLRecibo.value = _temp.URLRecibo !== undefined && _temp.URLRecibo.value !== '' ? _temp.URLRecibo.value : ''
        this.form.FechaPresentacionDesde.value = _temp.FechaPresentacionDesde !== undefined && _temp.FechaPresentacionDesde.value !== '' ? _temp.FechaPresentacionDesde.value : ''
        this.form.FechaPresentacionHasta.value = _temp.FechaPresentacionHasta !== undefined && _temp.FechaPresentacionHasta.value !== '' ? _temp.FechaPresentacionHasta.value : ''
        this.form.tipoPresentacionEstado.value = _temp.tipoPresentacionEstado !== undefined && _temp.tipoPresentacionEstado.value !== '' ? _temp.tipoPresentacionEstado.value : ''
        this.form.Error.value = _temp.Error !== undefined && _temp.Error.value !== '' ? _temp.Error.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        CodigoTramite: { label: i18n.t('presentations.CodigoTramite'), value: '' },
        DescripcionTramite: { label: i18n.t('presentations.DescripcionTramite'), value: '' },
        Asunto: { label: i18n.t('presentations.Asunto'), value: '' },
        Telefono: { label: i18n.t('presentations.Telefono'), value: '' },
        Email: { label: i18n.t('presentations.Email'), value: '' },
        PresentarRecurso: { label: i18n.t('presentations.PresentarRecurso'), value: '' },
        Observaciones: { label: i18n.t('presentations.Observaciones'), value: '' },
        NumAsiento: { label: i18n.t('presentations.NumAsiento'), value: '' },
        CSVRecibo: { label: i18n.t('presentations.CSVRecibo'), value: '' },
        URLRecibo: { label: i18n.t('presentations.URLRecibo'), value: '' },
        FechaPresentacionDesde: { label: i18n.t('presentations.FechaPresentacionDesde'), value: '' },
        FechaPresentacionHasta: { label: i18n.t('presentations.FechaPresentacionHasta'), value: '' },
        tipoPresentacionEstado: { label: i18n.t('presentations.Estado'), value: '' },
        Error: { label: i18n.t('presentations.Error'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
  }
}
</script>
